import { render } from "./AuthorCard.vue?vue&type=template&id=12f71002&scoped=true"
import script from "./AuthorCard.vue?vue&type=script&lang=js"
export * from "./AuthorCard.vue?vue&type=script&lang=js"

import "./AuthorCard.vue?vue&type=style&index=0&id=12f71002&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f71002"]])

export default __exports__